import axios from "axios";

const getInventory = (productNumber, customerNumber) => {
  const productNumberParam = productNumber
    ? `skuItemName=${productNumber}&`
    : "";
  const skuQuantityParam = `skuQuantity=1&`;
  const customerNumberParam = customerNumber
    ? `customerNumber=${customerNumber}`
    : "";

  const url = `/ignitionapi/InventoryTool/GetInventoryDetailsAndSAPLeadTime?${productNumberParam}${skuQuantityParam}${customerNumberParam}`;
  const config = {
    headers: { Pragma: "no-cache" }
  };

  return axios.get(url, config);
};

export default {
  getInventory
};
